export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-wheelchair-a9029b5ae977ec24353cf7e7004bc266.svg";